import React, { useEffect, useRef, useCallback } from "react"
import Box from "@mui/material/Box"
import { useInfoStore } from "../../store/userInfo";
import { useOrderStore } from "../../store/order";
import { List, ListItem, Typography } from "@mui/material";
import { useMenuStore } from "../../store/menuState";
import { IMenu } from "../../types/menu";
import { useTranslation } from "react-i18next";
import { isBrowser } from 'react-device-detect';
import { useWindowDimensions } from "../../App";

import { useAnalytics } from "../../analytics/AnalyticsContext";
import { devLog, menuLog } from "../../utils/logger";

const MenuTab = () => {
  const { userInfo, tableInfo, currentLng } = useInfoStore();
  const { width, orientation } = useWindowDimensions();
  const storeId = userInfo?.storeId;
  const tableId = tableInfo.id
  const { t } =  useTranslation([`${storeId}`])
  const {  totalOrderTimeLimit, remainingOrderTime: remaining, setSelectedMenu, fetchMenus, setVisibleMenus, isNativeFlag } = useMenuStore();
  const { recordEvent } = useAnalytics();
  const topMenus = useMenuStore((state) => state.topMenus);
  const selectedMenu = useMenuStore((state) => state.selectedMenu);
  const listRef = useRef<HTMLUListElement>(null);


  // console.log('tab', width)
  useEffect(() => {
    if (userInfo && storeId !== 0) {
      fetchMenus(userInfo, storeId as number, tableId);
    }
  }, [userInfo, storeId, tableId, fetchMenus]);

  // AYCE 선택 후 첫 번째 메뉴 자동 선택
  useEffect(() => {
    const { selectedAyce } = useOrderStore.getState();
    if (selectedAyce && topMenus && topMenus.length > 0 && !selectedMenu) {
      // 첫 번째 메뉴를 자동으로 선택
      const firstMenu = topMenus[0];
      if (firstMenu) {
        setSelectedMenu(firstMenu);
      }
    }
  }, [topMenus, selectedMenu, setSelectedMenu]);

  const handleSelectMenu = (
    item: IMenu,
    e: React.MouseEvent<HTMLElement>
  ) => {
    setSelectedMenu(item);

    // Pinpoint 이벤트 기록
    if (!isNativeFlag) {
      recordEvent('menu_click', true, {
        menuId: item.id,
        menuName: t(`${storeId}:menuNames.${item.id}.${currentLng}`),
        menuIndex: item.index,
        isVisible: item.visible,
        isAyce: Boolean(userInfo?.isAyce),
        storeId: storeId || 'unknown',
        tableId: tableId || 'unknown'
      });
    } else {
      if (window.Android !== undefined)
        window.Android.postMessage(JSON.stringify({ 
          type: 'attr', 
          data: {
            function: 'menu_click', 
            menuId: item.id, 
            menuName: t(`${storeId}:menuNames.${item.id}.${currentLng}`), 
            menuIndex: item.index,
            isVisible: item.visible,
            isAyce: Boolean(userInfo?.isAyce),
            storeId: storeId || 'unknown',
            tableId: tableId || 'unknown'
          } 
        }));
    }

    if (listRef.current) {
      const container = listRef.current;
      const listWidth = container.offsetWidth;
      const itemEl = e.currentTarget;
      const scrollPos =
        itemEl.offsetLeft - listWidth / 2 + itemEl.offsetWidth / 2;

      container.scrollTo({
        left: scrollPos,
        behavior: "smooth",
      });
    }

    // if (!isBrowser) {
    //   if (window.ReactNativeWebView !== undefined) {
    //     window.ReactNativeWebView.postMessage(JSON.stringify({ 'type': 'play' }));
    //   } else if (window.Android !== undefined) {
    //     window.Android.postMessage(JSON.stringify({ 'type': 'play' }));
    //   }
    // }
  };

  useEffect(() => {
    const setNativeData = (event: MessageEvent) => {
      devLog("Raw Event Data:", event.data);
      try {
        const data = typeof event.data === "string" ? JSON.parse(event.data) : event.data;
        // devLog("Parsed Data: time-limit", JSON.stringify(data), remaining);
        
        // Handle promotion tab selection
        if (data.action === "startPromotionTabSelect") {
          const promotionItem = topMenus && topMenus.length > 0 ? topMenus[0] : null;
          if (promotionItem) {
            setSelectedMenu(promotionItem);
            devLog("Promotion 액션으로 메뉴 선택:", promotionItem);
          } else {
            devLog("topMenus가 비어있어 선택할 메뉴가 없습니다");
          }
          devLog("Promotion Start:", data.action);
          // if(totalOrderTimeLimit.useAyceTimeLimit) {
          //   window.Android.postMessage(JSON.stringify({ 'type': 'time-limit', data: remaining }));
          // }
        }
        
      } catch (error) {
        devLog("Error parsing message:", error, event.data);
      }
    };

    const documentMessageHandler = (e: any) => {
      devLog("Document message event:", e);
      setNativeData(e as MessageEvent);
    };

    // 리액트 네이티브에서 보내는 메시지 이벤트 리스너
    window.addEventListener("message", setNativeData);
    
    // document 레벨 이벤트도 리스닝 (일부 React Native 구현에서 사용)
    document.addEventListener("message", documentMessageHandler);
    
    return () => {
      window.removeEventListener("message", setNativeData);
      document.removeEventListener("message", documentMessageHandler);
    };
  }, [topMenus, setSelectedMenu]);
  
  const checkSelectMenu = (item: IMenu) => {
    return selectedMenu && item.id === selectedMenu.id ? true: false
  }
  if(!topMenus) return <></>
  // console.log('isBrowser', isBrowser)
  return (
    <Box sx={{ width: '100%', pb: '.6rem', mt: '.8rem', backgroundColor: '#f4f4f4'}}>
      <List 
          ref={listRef} style={{ overflow: 'overlay', overflowY: 'hidden', display: 'inline-flex', gap: '.4rem', alignItems: 'flex-start', paddingTop: '0rem',
            width: `calc(100%)`, paddingBottom: '.6rem', paddingRight: '1rem', zIndex: 999 }}>
          {topMenus.map((item: IMenu, index: number) => {
            return(
              ((!userInfo?.isAyce && item.visible) || (userInfo?.isAyce)) && (
                <ListItem key={item.id} sx={[{display: 'inline-flex', padding: '0rem 5rem', borderRadius: '3rem', justifyContent: 'center', ml: '1rem', 
                  width: 'auto', flex: '0 0 auto', flexWrap: 'nowrap',},
                  checkSelectMenu(item) ? {backgroundColor: '#F72E13', height: '5rem'}
                  : {backgroundColor: '#fff', height: '5rem'}]} onClick={(e) => handleSelectMenu(item, e)}>
                  <Typography sx={[checkSelectMenu(item) ? {color: '#fff', fontWeight: '600', fontSize:'1.8rem'}: {color: '#F72E13',fontWeight: '600', fontSize: '1.8rem'},
                    { textAlign: 'center', alignItems: 'center', textTransform: 'none', overflow: 'hidden', whiteSpace: 'normal', textWrap: 'break-word', display: '-webkit-box',
                      WebkitLineClamp: 2, WebkitBoxOrient: 'vertical',  textOverflow: 'ellipsis'}]}>{t(`${storeId}:menuNames.${item.id}.${currentLng}`)}</Typography>
                </ListItem>)
              )
            })}
      </List>
    </Box>
  )
}

export default MenuTab


